class BuyBoxPricing extends Theme.Component {
  connectedCallback() {
    this.defineElements({
      price: "[data-bb-price]",
      comparePrice: "[data-bb-compare-price]",
      renews: "[data-bb-renews]",
      shipping: "[data-bb-shipping]",
      discount: "[data-bb-discount]"
    });

    this.form = this.closest("form");

    if (this.form) {
      this.form.addEventListener("change", () => this.render(), { signal: this.controller.signal });
    }

    document.addEventListener("productformvariants:change", (event) => {
      const id = event.detail?.variant?.id;
      if (id) {
        this.currentVariantId = Number(id);
      }
      this.render();
    }, { signal: this.controller.signal });

    this.render();
  }

  get controller() {
    return this._controller || (this._controller = new AbortController());
  }

  disconnectedCallback() {
    this._controller?.abort();
  }

  currentVariant() {
    const idInput = this.form?.querySelector("[name=id]");
    const id = idInput ? Number(idInput.value) : this.currentVariantId || this.data.initial_variant_id;
    return this.data.variants.find((v) => v.id === id) || this.data.variants[0];
  }

  currentSellingPlanId() {
    const planInput = this.form?.querySelector("[name=selling_plan]:checked");
    if (planInput) {
      const value = planInput.value;
      return value ? Number(value) : null;
    }
    const hiddenPlanInput = this.form?.querySelector("input[type='hidden'][name=selling_plan]");
    if (hiddenPlanInput) {
      const value = hiddenPlanInput.value;
      return value ? Number(value) : null;
    }
    return this.data.initial_selling_plan || null;
  }

  render() {
    const variant = this.currentVariant();
    if (!variant) return;

    const sellingPlanId = this.currentSellingPlanId();
    const allocation = sellingPlanId
      ? variant.selling_plan_allocations.find((a) => a.selling_plan_id === sellingPlanId) || variant.selling_plan_allocations[0]
      : null;

    const price = this.data.manual_price_override || (allocation ? allocation.price : variant.price);
    const compare = allocation
      ? (allocation.compare_at_price || 0) + (this.data.subscription_gift_compare_total || 0)
      : variant.compare_at_price;

    if (this.elements.price) {
      this.elements.price.textContent = this.formatMoney(price);
    }

    if (this.elements.comparePrice) {
      if (compare && compare > price) {
        this.elements.comparePrice.textContent = this.formatMoney(compare);
        this.elements.comparePrice.style.display = "";
      } else {
        this.elements.comparePrice.textContent = "";
        this.elements.comparePrice.style.display = "none";
      }
    }

    if (this.elements.discount) {
      if (compare && compare > price) {
        this.elements.discount.textContent = `SAVE ${this.formatMoney(compare - price)}`;
        this.elements.discount.style.display = "";
      } else {
        this.elements.discount.textContent = "";
        this.elements.discount.style.display = "none";
      }
    }
  }

  formatMoney(cents) {
    if (cents == null) return "";
    const dollars = cents / 100;
    return dollars % 1 === 0 ? `$${dollars}` : `$${dollars.toFixed(2)}`;
  }
}

customElements.define("component-buy-box-pricing", BuyBoxPricing);
